import React, { useState } from 'react';
import { NavList } from '../DesktopNavbar/DesktopList/NavList';
import { ScrollableProvider, useScrollable } from '../../../Scrollable/ScrollableProvider';
import { NextButton, PrevButton, ScrollableViewport, Scrollbar } from '../../../Scrollable/ScrollableContainer';
import './DropdownNav.scss';

export const DropdownNav = (props) => {
  const [hoveredChild, setHoveredChild] = useState(null);
  const {
    menu,
    isOffer,
    isSecondary,
    isSelected = false,
    isDesktop = false,
    isLoginMenu = false,
    level,
    rel,
    position
  } = props;

  var itemClass;

  const hasNested = menu.some((item) => Array.isArray(item.childItems) && item.childItems.length > 0);

    const ScrollableController = () => {
    const { isVerticalOverflowing } = useScrollable();

    return (
      <>
        {isVerticalOverflowing && (
          <div className="controller">
            <PrevButton className='btn-scrollbar prev neutral-020' />

            <Scrollbar orientation="vertical" />

            <NextButton className='btn-scrollbar next neutral-020' />
          </div>
        )}
      </>
    );
  };

  const switchClass = (level) => {
    switch (level) {
      case 1:
        itemClass = 'primary-dropdown-menu';
        break;

      case 2:
        itemClass = 'secondary-dropdown-menu';
        break;

      default:
        itemClass = '';
    }

    return itemClass;
  };

  return (
    <ul 
      className={`${switchClass(level)} ${isOffer && 'offer-dropdown'} ${isSelected && 'show'} ${position}`}
      onMouseLeave={() => {
        setHoveredChild(undefined);
      }}
    >
      {isOffer ? (
        <>
          <a
            href='tel:02130762309'
            className='button call'
          >
            <svg className='' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path className='' fillRule="evenodd" clipRule="evenodd" d="M2.00781 4.99997C2.00781 3.34604 3.34834 2.00684 5.00003 2.00684H8.27927C9.13619 2.00684 9.89776 2.55521 10.1692 3.36943L11.667 7.86287C11.9809 8.80451 11.5543 9.83299 10.6677 10.2763L9.3047 10.9578C10.1935 12.5126 11.4877 13.8066 13.0429 14.6952L13.7249 13.3312C14.1685 12.4439 15.1964 12.0187 16.1363 12.332L20.6298 13.8298C21.4429 14.1008 21.9922 14.8622 21.9922 15.7207V19C21.9922 20.6539 20.6517 21.9931 19 21.9931H18C9.16864 21.9931 2.00781 14.8336 2.00781 5.99998V4.99997ZM5.00003 3.99311C4.44258 3.99311 3.99225 4.44477 3.99225 4.99997V5.99998C3.99225 13.7349 10.2629 20.0068 18 20.0068H19C19.5575 20.0068 20.0078 19.5552 20.0078 19V15.7207C20.0078 15.7184 20.0063 15.7155 20.0028 15.7143L15.5093 14.2165C15.5073 14.2158 15.5067 14.2159 15.5065 14.2159L15.5065 14.2159C15.5062 14.2159 15.5058 14.216 15.5052 14.2161C15.5047 14.2162 15.504 14.2164 15.5033 14.2167C15.5026 14.217 15.502 14.2174 15.5015 14.2176C15.5011 14.2179 15.5008 14.2181 15.5007 14.2183L15.5004 14.2186L15.4995 14.2202L14.3708 16.4774C14.1326 16.9539 13.5613 17.1573 13.076 16.9385C10.4108 15.7368 8.2645 13.5906 7.06265 10.925C6.84349 10.4389 7.04699 9.86634 7.52363 9.62802L9.78089 8.49939L9.78271 8.49832L9.78304 8.49803C9.78329 8.49776 9.78387 8.497 9.7844 8.49574C9.78492 8.49447 9.78501 8.4936 9.78502 8.49339L9.78501 8.49322L9.78455 8.49151L8.28674 3.99807L9.20054 3.6929L8.28674 3.99807C8.28592 3.9956 8.28321 3.99311 8.27927 3.99311H5.00003Z" />
            </svg>

            Hubungi Kami
          </a>

          <div className='separator'>
            <span className="font-size-0875">Atau</span>
          </div>

          <a
            href='https://api.whatsapp.com/send/?phone=6282330030027&text=Halo%20Lifepal%2C%20saya%20memiliki%20pertanyaan%20tentang%20produk%20asuransi'
            className='button whatsapp'
            style={{marginBottom:'12px'}}
          >
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
              <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M15.3774 3.3022C13.6853 1.60815 11.4351 0.67481 9.03756 0.673828C4.09766 0.673828 0.0770898 4.69407 0.0751616 9.6355C0.0744704 11.2151 0.487169 12.7569 1.27149 14.1161L0 18.7603L4.75109 17.514C6.06012 18.228 7.534 18.6043 9.034 18.6049H9.03763C9.03734 18.6049 9.03793 18.6049 9.03763 18.6049C13.977 18.6049 17.9979 14.5842 18 9.64267C18.0009 7.2479 17.0695 4.99617 15.3774 3.3022ZM9.0376 17.0912H9.03458C7.69797 17.0907 6.38693 16.7316 5.2432 16.0529L4.97123 15.8915L2.15186 16.631L2.90442 13.8822L2.72729 13.6003C1.98164 12.4143 1.58782 11.0435 1.5884 9.63601C1.59 5.52889 4.93175 2.1875 9.04062 2.1875C11.0303 2.18812 12.9006 2.96401 14.307 4.37203C15.7134 5.78006 16.4875 7.65165 16.4867 9.64205C16.4851 13.7495 13.1434 17.0912 9.0376 17.0912Z" fill="white"/>
              
              <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M13.1234 11.5121C12.8995 11.4 11.7985 10.8583 11.5932 10.7835C11.3879 10.7088 11.2386 10.6714 11.0894 10.8956C10.9401 11.1197 10.5109 11.6242 10.3803 11.7737C10.2497 11.9231 10.119 11.9419 9.89512 11.8297C9.67119 11.7176 8.94963 11.4811 8.09429 10.7182C7.42853 10.1244 6.97912 9.3911 6.84845 9.16685C6.71784 8.94271 6.83455 8.82152 6.94667 8.70984C7.04741 8.60946 7.17063 8.4483 7.28261 8.31751C7.39455 8.1868 7.43188 8.0933 7.50653 7.94396C7.58118 7.79447 7.54389 7.66368 7.48787 7.55163C7.43188 7.43955 6.98404 6.33729 6.79744 5.88883C6.61561 5.45223 6.43102 5.51139 6.29354 5.50444C6.16311 5.49793 6.01363 5.49658 5.86436 5.49658C5.71509 5.49658 5.47243 5.55264 5.26721 5.77678C5.06195 6.00099 4.4834 6.54281 4.4834 7.64495C4.4834 8.74724 5.28584 9.81209 5.39782 9.9615C5.50976 10.111 6.9769 12.3729 9.22332 13.3429C9.7576 13.5736 10.1747 13.7114 10.4999 13.8146C11.0364 13.9851 11.5246 13.961 11.9104 13.9033C12.3407 13.839 13.2354 13.3616 13.422 12.8386C13.6086 12.3154 13.6086 11.867 13.5526 11.7736C13.4966 11.6803 13.3473 11.6242 13.1234 11.5121Z" fill="white"/>
            </svg>

            Chat di Whatsapp
          </a>

          <hr className='hr' />

          <div className='box'>
            Senin - Jumat<br />
            <strong>08.00 - 19.00 WIB</strong>
          </div>

          <div className='box'>
            Sabtu<br />
            <strong>08.00 - 17.00 WIB</strong>
          </div>

          <div className='box'>
            Hari libur nasional<br />
            <strong>Tutup</strong>
          </div>
        </>

      ) : (
        <div className="scrollable vertical">
          <ScrollableProvider vertical>
            <ScrollableViewport className={`${hasNested ? 'has-nested' : ''}`}>
                {menu.map(item => (
                  <NavList
                    isSecondary={isSecondary}
                    level={level}
                    key={item.title}
                    item={item}
                    isDesktop={isDesktop}
                    onMouseOver={() => {
                      setHoveredChild(item);
                    }}
                    onMouseLeave={() => {
                      setHoveredChild(undefined);
                    }}
                    isSelected={hoveredChild && hoveredChild.title === item.title}
                  />
                ))}
              </ScrollableViewport>
            <ScrollableController />
          </ScrollableProvider> 
        </div>
      )}
    </ul>
  );
};